// Close the dropdown if the user clicks outside of it
window.onclick = function (event) {
  //console.log(event.target);
  if (!event.target.matches(".dropbtn")) {
    const dropdowns = document.getElementsByClassName("dropdown-content");
    let i;
    for (i = 0; i < dropdowns.length; i++) {
      const openDropdown = dropdowns[i];
      if (openDropdown.classList.contains("show")) {
        toggle(openDropdown, true);
        //$(openDropdown).toggle(false);
        openDropdown.classList.remove("show");
      }
    }
  }
};

document.addEventListener("DOMContentLoaded", function () {
  const reviewArea = document.querySelector(".review-area");
  if (reviewArea) {
    reviewArea.addEventListener("click", function (e) {
      const moreBtn = e.target.closest(".more");
      if (!moreBtn) return;

      const sliderBox = moreBtn.closest(".slider-box");
      if (!sliderBox) return;

      const additional = sliderBox.querySelector(".additional");
      if (!additional) return;

      if (additional.classList.contains("d-none")) {
        document.querySelectorAll(".slider-box").forEach(function (box) {
          box.style.height = "400px";
        });
        moreBtn.textContent = "Read less";
      } else {
        document.querySelectorAll(".slider-box").forEach(function (box) {
          box.style.height = "250px";
        });
        moreBtn.textContent = "Read more";
      }

      additional.classList.toggle("d-none");
    });
  }

  const vidModalEl = document.getElementById("vidModal");
  if (vidModalEl) {
    const vidModal = new bootstrap.Modal(vidModalEl);
    document.querySelectorAll(".btn.vid-btn").forEach(function (btn) {
      btn.addEventListener("click", function () {
        const iframe = vidModalEl.querySelector(".embed-responsive-item");
        if (iframe) {
          iframe.setAttribute("src", this.getAttribute("data-src"));
        }
        vidModal.show();
      });
    });

    const vidClose = vidModalEl.querySelector(".close");
    if (vidClose) {
      vidClose.addEventListener("click", function () {
        vidModal.hide();
      });
    }

    vidModalEl.addEventListener("hidden.bs.modal", function () {
      const iframe = this.querySelector(".embed-responsive-item");
      if (iframe) {
        iframe.src = "";
      }
    });
  }
});

setTimeout(
  function () {
    window.onload = (async function () {
      if (document.querySelector(".glide")) {
        const script3 = document.createElement("script");
        script3.type = "text/javascript";
        script3.src = "https://unpkg.com/@glidejs/glide@3.6.0/dist/glide.min.js";

        // Load the script and initialize Glide once loaded
        script3.onload = function () {
          // Use 'slider' with bound and rewind disabled so the carousel does not
          // loop back to older slides and is bounded to the first/last slide.
          window._glideInstance = new Glide(".glide", {
            type: "slider",
            startAt: 0,
            perView: 3,
            gap: 40,
            rewind: false,
            bound: true,
            breakpoints: {
              992: {
                perView: 2,
              },
              767: {
                perView: 1,
                peek: 70,
                gap: 20,
              },
              575: {
                perView: 1,
                peek: 25,
                gap: 10,
              },
            },
          });
          window._glideInstance.mount();
        };

        document.head.appendChild(script3);
      }

      let url = window.location.href;
      //remove qury string from url
      url = url.split("?")[0];
      const request = await fetch("/php/popup.php").then((response) => response.json());
      //if route is pages/search-results then return
      if (!request) return;

      const copyCode = async (text, button = null) => {
        const textToCopy = text.replace("📋", "").replace("✅", "").trim();

        try {
          await window.navigator.clipboard.writeText(textToCopy);
          if (button) {
            button.innerText = "✅";
            setTimeout(() => (button.innerText = "📋"), 2000);
          }
        } catch (err) {
          console.error("Failed to copy text:", err);
        }
      };
      let rightSideBarSet = false;
      let modalSet = false;

      const createPopupContent = (message) => {
        const modal = document.createElement("div");
        modal.classList.add("modal", "fade");
        modal.setAttribute("id", "messageModal");
        modal.setAttribute("tabindex", "-1");
        modal.setAttribute("aria-labelledby", "messageModalLabel");
        modal.setAttribute("aria-hidden", "true");
        modal.style.zIndex = "999999";

        modal.innerHTML = `
<div class="modal-dialog modal-dialog-centered"> <!-- Centering the modal -->
    <div class="modal-content" style="border-radius: 12px; box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);">
        <div class="modal-body" style="padding: 20px; text-align: center;">
            <p class="mt-4">${message.content}</p>
            <div style="display: flex; flex-direction: column; align-items: center;">
            <a id="modal-link-${message.id}"  href="${message.link}" class="btn mt-3 mb-4" target="_blank" 
                style="background:#e9531d; border-color:#e9531d; color:#fff;">${message.link_text}</a>
            </div
        </div>
        <div class="modal-footer" style="display:flex; justify-content: flex-end; border-bottom-left-radius: 12px; border-bottom-right-radius: 12px;">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        </div>
    </div>
</div>`;

        document.body.appendChild(modal);

        // Initialize Bootstrap modal
        const bootstrapModal = new bootstrap.Modal(modal, {
          backdrop: "static",
          keyboard: false,
        });

        bootstrapModal.show();
        localStorage.setItem("lastMessageDate" + message.id, message.last_updated);

        setTimeout(() => {
          //get everything inide code tag inside message.content
          try {
            let code = message.content.match(/<code>(.*?)<\/code>/gs);
            code = code.map((c) => c.replace(/<[^>]*>/g, ""));

            if (code && code.length > 0) {
              //Ammend href with code
              const modalLink = document.getElementById(`modal-link-${message.id}`);
              modalLink.href = modalLink.href + "?code=" + encodeURIComponent(code[0]);

              // const codeCopyButton = document.getElementById(`code-copy-${message.id}`);
              // codeCopyButton.addEventListener("click", () => copyCode(code[0]));
            }
          } catch (error) {}

          //when modal is closed remove it from the dom and create sidebar widget if not already created
          modal.addEventListener("hidden.bs.modal", () => {
            modal.remove();
            if (!rightSideBarSet) createSidebarWidget(message);
          });
        }, 100);
      };

      const createPopup = (message) => {
        modalSet = true;
        setTimeout(
          () => {
            createPopupContent(message);
          },
          message.delay != 0 ? parseFloat(message.delay) * 1000 : 0,
        );
      };

      const createSidebarWidget = (message) => {
        rightSideBarSet = true;
        const content = `<div style="
              position: fixed;
              right: 0;
              top: 50%;
              transform: translateY(-50%);
              width: 40px;
              height: 200px;
              background-color: #E9531D;
              color: white;
              writing-mode: vertical-rl;
              text-align: center;
              font-size: 16px;
              font-weight: bold;
              display: flex;
              align-items: center;
              justify-content: center;
              z-index: 999999;
              border-top-left-radius: 4px;
              border-bottom-left-radius: 4px;
              cursor: pointer;
              opacity: 0;
              transition: opacity 0.5s;
          " id="fadeInBanner">
              ${message.sb_widget_text || "New Offer"}
          </div>
          `;
        document.body.insertAdjacentHTML("beforeend", content);
        setTimeout(() => {
          const fadeInBanner = document.getElementById("fadeInBanner");
          fadeInBanner.addEventListener("click", () => createPopupContent(message));
          fadeInBanner.style.opacity = 1;
        }, 250);
      };

      const checkUrls = (messageData) => {
        let allowed = false;
        let urls = JSON.parse(messageData.urls_allowed || "[]");
        urls.forEach((u) => {
          if (url.endsWith("/") && !u.endsWith("/")) {
            u = u + "/";
          } else if (!url.endsWith("/") && u.endsWith("/")) {
            url = url + "/";
          }

          if (u === url) {
            allowed = true;
          }
        });
        return allowed;
      };

      try {
        for (const messageData of request) {
          let lastMessageDate = localStorage.getItem("lastMessageDate" + messageData.id);
          if (lastMessageDate !== messageData.last_updated) {
            if (messageData.restrict_urls !== 0) {
              if (checkUrls(messageData)) {
                createPopup(messageData);
                break;
              }
            } else {
              createPopup(messageData);
              break;
            }
          }
        }

        if (!rightSideBarSet && !modalSet) {
          for (const messageData of request) {
            if (rightSideBarSet) break;
            if (messageData.sb_widget_active !== 0) {
              if (messageData.restrict_urls !== 0 && checkUrls(messageData)) {
                createSidebarWidget(messageData);
              } else if (messageData.restrict_urls === 0) {
                createSidebarWidget(messageData);
              }
            }
          }
        }
      } catch (error) {
        console.error("Error fetching popup data", error);
      }
    })();
  },

  576 > window.innerWidth ? 1500 : 0,
);

gtag("consent", "default", {
  ad_storage: "denied",
  analytics_storage: "denied",
});

// Check user consent and enable appropriate features
if (userHasGivenConsent("analytics")) {
  enableAnalytics();
}

if (userHasGivenConsent("ads")) {
  enableAds();
}

// (function() {
//     var button = document.querySelector('#show');
//     var box = document.querySelector('.link-box');
//     button.addEventListener('click', function() {
//         box.classList.toggle('active');
//     });
// })();
const navicon = document.getElementById("navicon");
if (navicon) {
  navicon.onclick = function () {
    this.classList.toggle("open");
  };
}

document.addEventListener("DOMContentLoaded", function () {
  const showBtn = document.querySelector(".foll-area #show");
  if (showBtn) {
    showBtn.addEventListener("click", function () {
      const follArea = document.querySelector(".foll-area");
      if (!follArea) return;
      follArea.classList.toggle("active");
      const showText = follArea.querySelector(".show-text");
      if (showText) {
        showText.innerHTML = follArea.classList.contains("active") ? "Show less" : "Show more";
      }
    });
  }

  document.querySelectorAll(".password-eye").forEach(function (eye) {
    eye.addEventListener("click", function () {
      const parent = this.parentElement;
      if (!parent) return;
      const input = parent.querySelector("input");
      if (!input) return;
      input.setAttribute("type", input.getAttribute("type") === "password" ? "text" : "password");
    });
  });
});

const logoGrid = document.getElementById("logoGrid");

if (logoGrid) {
  function setupInfiniteScroll() {
    // Remove any existing clones first
    Array.from(logoGrid.querySelectorAll(".clone")).forEach((c) => c.remove());
    const logos = Array.from(logoGrid.children);
    logos.forEach((logo) => {
      const clone = logo.cloneNode(true);
      clone.classList.add("clone");
      logoGrid.appendChild(clone);
    });
  }

  let scrollSpeed = 1;
  let animationFrame;

  function animateScroll() {
    logoGrid.scrollLeft += scrollSpeed;
    if (logoGrid.scrollLeft >= logoGrid.scrollWidth / 2) {
      logoGrid.scrollLeft = 0;
    }
    animationFrame = requestAnimationFrame(animateScroll);
  }

  function stopScroll() {
    cancelAnimationFrame(animationFrame);
  }

  function startScroll() {
    if (window.innerWidth < 900) {
      if ("requestIdleCallback" in window) {
        requestIdleCallback(() => {
          animationFrame = requestAnimationFrame(animateScroll);
        });
      } else {
        setTimeout(() => {
          animationFrame = requestAnimationFrame(animateScroll);
        }, 1500);
      }
    }
  }

  logoGrid.addEventListener("mouseenter", stopScroll);
  logoGrid.addEventListener("mouseleave", startScroll);
  window.addEventListener("resize", () => {
    stopScroll();
    setupInfiniteScroll();
    startScroll();
  });

  if (window.innerWidth < 900) {
    setupInfiniteScroll();
    startScroll();
  }
}

if (document.querySelector(".floating-cta-exit-modal-overlay")) {
  fetch("/php/exitmodal.php")
    .then((response) => response.json())
    .then((data) => {
      if (data && data == 1) {
        let exitIntentShown = false;

        function showExitModal() {
          if (!exitIntentShown) {
            document.getElementById("exitModal").classList.add("visible");
            exitIntentShown = true;
          }
        }

        // Utility: check if user is on mobile using screen width
        function isMobileDevice() {
          return window.matchMedia("(pointer: coarse)").matches;
        }

        let seconds = 0;

        let secondsInterval = setInterval(() => {
          if (seconds !== 15) {
            seconds++;
          } else {
            clearInterval(secondsInterval);
          }
        }, 1000);

        if (!isMobileDevice()) {
          document.addEventListener("mouseleave", function (e) {
            if (e.clientY <= 0 && seconds === 15) {
              showExitModal();
            }
          });
        }

        // ---- Mobile: Scroll up quickly ----
        if (isMobileDevice()) {
          let lastScrollTop = 0;
          let scrollTimeout;

          window.addEventListener("scroll", function () {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

            // Check for fast upward scroll (exit intent)
            if (scrollTop < lastScrollTop - 100 && !exitIntentShown && seconds === 15) {
              showExitModal();
            }

            lastScrollTop = scrollTop;

            // Reset detection timer
            clearTimeout(scrollTimeout);
            scrollTimeout = setTimeout(() => {
              lastScrollTop = scrollTop;
            }, 150);
          });

          // Optional: Inactivity timeout (15s)
          let inactivityTimeout;
          function resetInactivityTimer() {
            clearTimeout(inactivityTimeout);
            inactivityTimeout = setTimeout(() => {
              showExitModal();
            }, 15000);
          }

          ["touchstart", "scroll", "click"].forEach((event) =>
            window.addEventListener(event, resetInactivityTimer),
          );
          resetInactivityTimer();
        }

        // ---- Close modal ----
        document.getElementById("exitClose").addEventListener("click", function () {
          document.getElementById("exitModal").classList.remove("visible");
        });
      }
    })
    .catch((error) => {});
}
/* Set the width of the side navigation to 500px */
function openCloseNav() {
  const nav = document.getElementById("mySidenav");
  if (nav.style.width === "500px") {
    nav.style.width = "0";
    document.getElementById("menu-btn").src = "images/menu.webp";
  } else {
    nav.style.width = "500px";
    document.getElementById("menu-btn").src = "images/cancel.webp";
  }
}

/* When the user clicks on the button, toggle between hiding and showing the dropdown content */

function toggle(el, hide = false) {
  if (hide) {
    el.style.display = "none";
  } else {
    if (el.style.display === "" || el.style.display === "none") {
      el.style.display = "block";
    } else {
      el.style.display = "none";
    }
  }
}

function LoginMenu() {
  toggle(document.getElementById("contactDropdown"), true);
  toggle(document.getElementById("menuDropdown"), true);
  toggle(document.getElementById("loginDropdown"));
  document.getElementById("loginDropdown").classList.add("show");
}

function ContactFunction() {
  toggle(document.getElementById("loginDropdown"), true);
  toggle(document.getElementById("menuDropdown"), true);
  toggle(document.getElementById("contactDropdown"));
  document.getElementById("contactDropdown").classList.add("show");
}

function MenuFunction() {
  toggle(document.getElementById("loginDropdown"), true);
  toggle(document.getElementById("contactDropdown"), true);
  toggle(document.getElementById("menuDropdown"));
  document.getElementById("menuDropdown").classList.add("show");
}

function contactToggle() {
  var el = document.getElementById("contactDropdown");
  if (el) {
    if (el.style.display === "none" || el.style.display === "") {
      el.style.display = "block";
    } else {
      el.style.display = "none";
    }
  }
}

// document.addEventListener("DOMContentLoaded", function() {
//     var lazyloadImages;

//     if ("IntersectionObserver" in window) {
//         lazyloadImages = document.querySelectorAll(".lazy");
//         var imageObserver = new IntersectionObserver(function(entries, observer) {
//             entries.forEach(function(entry) {
//                 if (entry.isIntersecting) {
//                     var image = entry.target;
//                     image.classList.remove("lazy");
//                     imageObserver.unobserve(image);
//                 }
//             });
//         });

//         lazyloadImages.forEach(function(image) {
//             imageObserver.observe(image);
//         });
//     } else {
//         var lazyloadThrottleTimeout;
//         lazyloadImages = document.querySelectorAll(".lazy");

//         function lazyload () {
//             if(lazyloadThrottleTimeout) {
//                 clearTimeout(lazyloadThrottleTimeout);
//             }

//             lazyloadThrottleTimeout = setTimeout(function() {
//                 var scrollTop = window.pageYOffset;
//                 lazyloadImages.forEach(function(img) {
//                     if(img.offsetTop < (window.innerHeight + scrollTop)) {
//                         img.src = img.dataset.src;
//                         img.classList.remove('lazy');
//                     }
//                 });
//                 if(lazyloadImages.length == 0) {
//                     document.removeEventListener("scroll", lazyload);
//                     window.removeEventListener("resize", lazyload);
//                     window.removeEventListener("orientationChange", lazyload);
//                 }
//             }, 20);
//         }

//         document.addEventListener("scroll", lazyload);
//         window.addEventListener("resize", lazyload);
//         window.addEventListener("orientationChange", lazyload);
//     }
// })

function registerDeferredThirdParties() {
  // Inject any deferred review slides into the Glide slider
  if (window._deferredReviews && window._deferredReviews.length > 0) {
    var slidesList = document.querySelector(".glide__slides");
    if (slidesList) {
      var showLocation = window._deferredReviewsShowLocation || false;
      window._deferredReviews.forEach(function (review, i) {
        var li = document.createElement("li");
        li.className = "glide__slide";
        var locationHtml = showLocation
          ? '<p class="h3">' + review.name + ", " + review.city + "</p>"
          : "";
        var additionalHtml =
          review.additional
            ? '<p class="d-none additional">' + review.additional + "</p>" +
              '<span class="more">Read more</span>'
            : "";
        li.innerHTML =
          '<div class="slider-box">' +
            '<div class="slider-header">' +
              '<p class="h4">' + review.first_name + "</p>" +
              locationHtml +
              '<p class="h3">' + review.submitted + "</p>" +
            "</div>" +
            '<div class="slider-body">' +
              '<p class="review-text">' +
                review.text +
                (review.additional ? ".." : "") +
              "</p>" +
              additionalHtml +
            "</div>" +
          "</div>";
        slidesList.appendChild(li);
      });
      window._deferredReviews = [];

      // Re-mount Glide to pick up the new slides if it is already initialised
      if (window._glideInstance) {
        window._glideInstance.update();
      }
    }
  }

  var Tawk_API = window.Tawk_API || {},
    Tawk_LoadStart = new Date();
  window.Tawk_API = Tawk_API;
  (function () {
    const s1 = document.createElement("script"),
      s0 = document.getElementsByTagName("script")[0];
    s1.async = true;
    s1.src = "https://embed.tawk.to/5acf26b94b401e45400e9096/default";
    s1.charset = "UTF-8";
    s1.setAttribute("crossorigin", "*");
    s0.parentNode.insertBefore(s1, s0);
  })();
  Tawk_API.onChatEnded = function () {
    wc_chat_ypbib("Chat", "New Chat Session");
  };
  Tawk_API.onOfflineSubmit = function () {
    wc_chat_ypbib("Chat", "New Chat Session");
  };

  const script = document.createElement("script");
  script.type = "text/javascript";
  script.src = "https://cdn.jsdelivr.net/gh/orestbida/cookieconsent@v2.8.9/dist/cookieconsent.js";
  script.onload = function () {
    // obtain cookieconsent plugin
    let cc = initCookieConsent();

    // run plugin with config object
    cc.run({
      autorun: true,
      current_lang: "en",
      autoclear_cookies: true,
      page_scripts: true,
      cookie_expiration: 365, // default: 182 (days)

      gui_options: {
        consent_modal: {
          layout: "box", // box/cloud/bar
          position: "bottom left", // bottom/middle/top + left/right/center
          transition: "slide", // zoom/slide
          swap_buttons: false, // enable to invert buttons
        },
        settings_modal: {
          layout: "box", // box/bar
          // position: 'left',           // left/right
          transition: "slide", // zoom/slide
        },
      },

      onFirstAction: function (user_preferences, cookie) {
        // callback triggered only once
        // [ajm] what is this
      },

      onAccept: function (cookie) {
        if (cc.allowedCategory("analytics")) {
          enableAnalytics();
        }

        if (cc.allowedCategory("ads")) {
          enableAds();
        }
      },

      onChange: function (cookie, changed_categories) {
        if (cc.allowedCategory("analytics")) {
          enableAnalytics();
        } else {
          disableAnalytics();
        }

        if (cc.allowedCategory("ads")) {
          enableAds();
        } else {
          disableAds();
        }
      },

      languages: {
        en: {
          consent_modal: {
            title: "Cookies",
            description:
              'This website uses essential cookies to ensure its proper operation and tracking cookies to understand how you interact with it. The latter will be set only upon approval. <a aria-label="Cookie policy" class="cc-link" href="cookie-policy">Read more</a>',
            primary_btn: {
              text: "Accept",
              role: "accept_all", // 'accept_selected' or 'accept_all'
            },
            secondary_btn: {
              text: "Settings",
              role: "settings", // 'settings' or 'accept_necessary'
            },
          },
          settings_modal: {
            title: "Cookie preferences",
            save_settings_btn: "Save settings",
            accept_all_btn: "Accept all",
            reject_all_btn: "Reject all", // optional, [v.2.5.0 +]
            cookie_table_headers: [
              { col1: "Name" },
              { col2: "Domain" },
              { col3: "Expiration" },
              { col4: "Description" },
              { col5: "Type" },
            ],
            blocks: [
              {
                title: "Cookie usage",
                description:
                  "I use cookies to ensure the basic functionalities of the website and to enhance your online experience. You can choose for each category to opt-in/out whenever you want.",
              },
              {
                title: "Strictly necessary cookies",
                description:
                  "These cookies are essential for the proper functioning of my website. Without these cookies, the website would not work properly.",
                toggle: {
                  value: "necessary",
                  enabled: true,
                  readonly: true,
                },
              },
              {
                title: "Analytics cookies",
                description:
                  "These cookies collect information about how you use the website, which pages you visited and which links you clicked on. All of the data is anonymized and cannot be used to identify you.",
                toggle: {
                  value: "analytics",
                  enabled: false,
                  readonly: false,
                },
                cookie_table: [
                  {
                    col1: "^_ga",
                    col2: "google.com",
                    col3: "2 years",
                    col4: "description ...",
                    col5: "Permanent cookie",
                    is_regex: true,
                  },
                  {
                    col1: "_gid",
                    col2: "google.com",
                    col3: "1 day",
                    col4: "description ...",
                    col5: "Permanent cookie",
                  },
                ],
              },
              {
                title: "Advertising",
                description:
                  "These cookies are used to track advertising effectiveness to provide a more relevant service and deliver better ads to suit your interests.",
                toggle: {
                  value: "ads",
                  enabled: false,
                  readonly: false,
                },
              },
              {
                title: "More information",
                description:
                  'For any queries in relation to my policy on cookies and your choices, please <a class="cc-link" href="contact">contact us</a>.',
              },
            ],
          },
        },
      },
    });
  };
  document.body.appendChild(script);

  window.removeEventListener("scroll", registerDeferredThirdParties);
  window.removeEventListener("touchstart", registerDeferredThirdParties);
}

window.addEventListener("scroll", registerDeferredThirdParties, { passive: true, once: true });
window.addEventListener("touchstart", registerDeferredThirdParties, { passive: true, once: true });

/* Helper functions to avoid repeating the same ga code */
function enableAnalytics() {
  //console.log("enabled analytics")
  gtag("consent", "update", {
    analytics_storage: "granted",
  });
}

function disableAnalytics() {
  //console.log("disabled analytics")
  // Default ad_storage to 'denied'.
  gtag("consent", "default", {
    analytics_storage: "denied",
  });
}

function enableAds() {
  //console.log("enabled ads")
  gtag("consent", "update", {
    ad_storage: "granted",
  });
}

function disableAds() {
  //console.log("disabled ads")
  gtag("consent", "update", {
    ad_storage: "denied",
  });
}

// Function to check if user has given consent for a specific category
function userHasGivenConsent(category) {
  const name = "cc_cookie=";
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      const cookieValue = c.substring(name.length, c.length);
      const consentData = JSON.parse(cookieValue);
      return consentData.categories.includes(category);
    }
  }
  return false;
}
